import { useFormikContext } from 'formik';
import * as Yup from 'yup'

import { FormikNotesArea } from "../../../../../components/widgets"
import { useEffect, useState } from 'react';
import { VerdictSelector } from '../../../../../components/layout';
import { IWebFileAttachment } from '../../../../core/applications';

export interface IDLMConfirmation  {
  verdict: string, 
  workflow: string,
  appState: string,
  note: string,
  noteAttachments: Array<IWebFileAttachment>,  
}

export const initDLMConfirmationValues = {
  verdict: '', 
  workflow: '',
  appState: '',
  note: '',
  noteAttachments: [],  
}

export const DLMConfirmationSchema: any = Yup.object({
  verdict: Yup.string().trim().required().label('Verdict'),    
  workflow: Yup.string().trim(),    
  appState: Yup.string().trim(),
  note: Yup.string().trim().required().label('Note'),    
  noteAttachments: Yup.array(),  
});

export const DLMConfirmationForm = () => {

  const [verdict, setVerdict] = useState('');
  const { setFieldValue, setStatus } = useFormikContext();    
  
  useEffect(() => {
    setVerdict('');
  },[])

  return (
  <>    
  <VerdictSelector
    verdict={verdict}
    setVerdict={setVerdict}
    setFieldValue={setFieldValue}
    setStatus={setStatus}
  />
  { (verdict) && 
  <FormikNotesArea required />
  }  
  </>
  )
}
